module.exports = __webpack_public_path__ + "static/media/400016_02.50a38b7a.png";